"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bytes = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.rule)({
    ...nano_theme_1.lightTheme.font.ui1.mid,
    d: 'inline-flex',
    ai: 'baseline',
    gap: '4px',
    fz: '13px',
    lh: '18px',
    whiteSpace: 'nowrap',
});
const valueClass = (0, nano_theme_1.drule)({});
const unitClass = (0, nano_theme_1.drule)({
    fz: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
});
const SI_UNITS = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB'];
const BIN_UNITS = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB'];
const format = (bytes, binary, precision) => {
    if (!Number.isFinite(bytes) || bytes === 0)
        return { n: '0', unit: 'B' };
    const sign = bytes < 0 ? '-' : '';
    const abs = Math.abs(bytes);
    const base = binary ? 1024 : 1000;
    const units = binary ? BIN_UNITS : SI_UNITS;
    const i = Math.min(units.length - 1, Math.floor(Math.log(abs) / Math.log(base)));
    const value = abs / base ** i;
    const fixed = i === 0 ? value.toFixed(0) : value.toFixed(precision);
    const trimmed = fixed.replace(/\.?0+$/, '');
    return { n: sign + trimmed, unit: units[i] };
};
const Bytes = ({ value, binary = false, precision = 1, className, style }) => {
    const styles = (0, context_1.useStyles)();
    const { n, unit } = React.useMemo(() => format(value, binary, precision), [value, binary, precision]);
    return (React.createElement("span", { className: blockClass + (className ? ` ${className}` : ''), style: style, title: `${value.toLocaleString()} bytes` },
        React.createElement("span", { className: valueClass({ col: styles.g(0.25) }) }, n),
        React.createElement("span", { className: unitClass({ col: styles.g(0.5) }) }, unit)));
};
exports.Bytes = Bytes;
